const CoffeeFlavorLexicon = [
  {
    "name": "Fruity",
    "children": [
      {
        "name": "Berry",
        "children": [
          {
            "name": "Strawberry",
          },
          {
            "name": "Raspberry",
          },
          {
            "name": "Blueberry",
          },
          {
            "name": "Balckberry",
          }
        ]
      },
      {
        "name": "Dried Fruit",
        "children": [
          {
            "name": "Raisin"
          },
          {
            "name": "Prune"
          }
        ]
      },
      {
        "name": "Other Fruit",
        "children": [
          {
            "name": "Apple"
          },
          {
            "name": "Pear"
          },
          {
            "name": "Peach"
          },
          {
            "name": "Grape"
          },
          {
            "name": "Cherry"
          },
          {
            "name": "Pomegranate"
          },
          {
            "name": "Coconut"
          },
          {
            "name": "Pineapple"
          }
        ]
      },
      {
        "name": "Citrus Fruit",
        "children": [
          {
            "name": "Lemon"
          },
          {
            "name": "Grapefruit"
          },
          {
            "name": "Orange"
          },
          {
            "name": "Lime"
          },
          {
            "name": "Passionfruit"
          }
        ]
      }
    ]
  },
  {
    "name": "Cocoa/Chocolate",
    "children": [

          {
            "name": "Chocolate"
          },
          {
            "name": "Cocoa"
          },
          {
            "name": "Dark Chocolate"
          }
      ]
  },
  {
    "name": "Sour / Acidic",
    "children": [

          {
            "name": "Acetic Acid"
          },
          {
            "name": "Butyric Acid"
          },
          {
            "name": "Isovaleric Acid"
          },
          {
            "name": "Citric Acid"
          },
          {
            "name": "Malic Acid"
          },
          {
            "name": "Phosphoric Acid"
          }
      ]
  },
  {
    "name": "Alcohol/Fermented",
    "children": [

          {
            "name": "Whiskey"
          },
          {
            "name": "Winey"
          },
          {
            "name": "Fermented"
          },
          {
            "name": "Overripe/Near Fermented"
          }
      ]
  },
  {
    "name": "Cereal",
    "children": [

          {
            "name": "Grain"
          },
          {
            "name": "Malt"
          }
      ]
  },
  {
    "name": "Spices",
    "children": [

          {
            "name": "Pungent"
          },
          {
            "name": "Pepper"
          },
          {
            "name": "Anise"
          },
          {
            "name": "Nutmeg"
          },
          {
            "name": "Brown Spice"
          },
          {
            "name": "Cinnamon"
          },
          {
            "name": "Clove"
          },
          {
            "name": "Cardamom"
          }
      ]
  },
  {
    "name": "Nutty",
    "children": [

          {
            "name": "Almond"
          },
          {
            "name": "Hazelnut"
          },
          {
            "name": "Peanuts"
          }
      ]
  },
  {
    "name": "Sweet",
    "children": [

          {
            "name": "Molasses"
          },
          {
            "name": "Maple Syrup"
          },
          {
            "name": "Brown Sugar"
          },
          {
            "name": "Caramelized"
          },
          {
            "name": "Honey"
          },
          {
            "name": "Vanilla"
          },
          {
            "name": "Vanillin"
          },
          {
            "name": "Sugar Cane"
          },
          {
            "name": "Cane Juice (Garapa)"
          }
      ]
  },
  {
    "name": "Floral",
    "children": [

          {
            "name": "Rose"
          },
          {
            "name": "Jasmine"
          },
          {
            "name": "Coffe Blossom"
          },
          {
            "name": "Chamomile"
          },
          {
            "name": "Black Tea"
          }
      ]
  },
  {
    "name": "Roasted",
    "children": [

          {
            "name": "Tobacco"
          },
          {
            "name": "Pipe Tobacco"
          },
          {
            "name": "Acrid"
          },
          {
            "name": "Ashy"
          },
          {
            "name": "Burnt"
          },
          {
            "name": "Smoky"
          },
          {
            "name": "Roasted"
          },
          {
            "name": "Brown, Roast"
          }
      ]
  },
  {
    "name": "Green/Vegetative",
    "children": [

          {
            "name": "Olive Oil"
          },
          {
            "name": "Raw"
          },
          {
            "name": "Under Ripe"
          },
          {
            "name": "Peapod"
          },
          {
            "name": "Green"
          },
          {
            "name": "Fresh"
          },
          {
            "name": "Dark Green"
          },
          {
            "name": "Vegetative"
          },
          {
            "name": "Hay-Like"
          },
          {
            "name": "Herb-Like"
          },
          {
            "name": "Beany"
          },
          {
            "name": "Astringent"
          }
      ]
  },
  {
    "name": "Earthy",
    "children": [

          {
            "name": "Woody"
          },
          {
            "name": "Musty/Earthy"
          },
          {
            "name": "Musty/Dusty"
          },
          {
            "name": "Moldy/Damp"
          },
          {
            "name": "Phenolic"
          },
          {
            "name": "Animalic"
          },
          {
            "name": "Meaty/Brothy"
          }
      ]
  },
  {
    "name": "Stale/Papery",
    "children": [

          {
            "name": "Stale"
          },
          {
            "name": "Papery"
          },
          {
            "name": "Cardboard"
          }
      ]
  },
  {
    "name": "Chemical",
    "children": [

          {
            "name": "Bitter"
          },
          {
            "name": "Salty"
          },
          {
            "name": "Medicinal"
          },
          {
            "name": "Rubber"
          },
          {
            "name": "Petroleum"
          },
          {
            "name": "Skunky"
          }
      ]
  }
]
;

export default CoffeeFlavorLexicon;



// WEBPACK FOOTER //
// ./src/components/CoffeeFlavorLexicon.js